import React, { useState, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import PropTypes from 'prop-types';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;

const PdfViewer = ({ file }) => {
  const [nPages, setNPages] = useState(null);
  const [containerWidth, setContainerWidth] = useState(600);
  const containerRef = useRef(null);

  const updateContainerWidth = () => {
    if (containerRef.current) {
      console.log('updateContiner', containerRef.current.offsetWidth);
      setContainerWidth(containerRef.current.offsetWidth);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', updateContainerWidth);
    return () => window.removeEventListener('resize', updateContainerWidth);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNPages(numPages);
    setTimeout(updateContainerWidth, 100);
  };

  return (
    <div ref={containerRef}>
      {file && (
        <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.from(new Array(nPages), (_, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} width={containerWidth} />
          ))}
        </Document>
      )}
    </div>
  );
};

PdfViewer.propTypes = {
  file: PropTypes.string,
};

PdfViewer.defaultProps = {
  file: '',
};

export default PdfViewer;
